let Summary1970=[
    {"Countryname":" ",
    "OZ":0,
    "ME":103,
    "NU":98,
    "DI":113,
    "HR":173,
    "CO":179,
    "EC":201,
    "OT":0
    }]
export default Summary1970